import React, { Component } from 'react';  
import { Route } from 'react-router-dom';  
import DashboardHeader from './header';

const PanelLayout = ({children, ...rest}) => {  
  return (  
    <div className="page page-dashboard">  
      <DashboardHeader />
      <div className="sidebar">
      </div>  
      <div className="main">{children}</div>  
    </div>  
  )  
}  
  
const PanelLayoutRoute = ({component: Component, ...rest}) => {  
  return (  
    <Route {...rest} render={matchProps => (  
      <PanelLayout>  
          <Component {...matchProps} />  
      </PanelLayout>  
    )} />  
  )  
};  

export default PanelLayoutRoute;